/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Submit_Autofill_FilledInputs */

const en_directory_submit_autofill_filled = /** @type {(inputs: Directory_Submit_Autofill_FilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Filled ${i?.count} fields from your website.`)
};

const zh_directory_submit_autofill_filled = /** @type {(inputs: Directory_Submit_Autofill_FilledInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已从网站填写 ${i?.count} 个字段。`)
};

/**
* | output |
* | --- |
* | "Filled {count} fields from your website." |
*
* @param {Directory_Submit_Autofill_FilledInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_autofill_filled = /** @type {((inputs: Directory_Submit_Autofill_FilledInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Autofill_FilledInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_autofill_filled(inputs)
	return zh_directory_submit_autofill_filled(inputs)
});
export { directory_submit_autofill_filled as "directory.submit.autofill_filled" }